import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { PropsWithChildren } from 'react'

import { Tooltip } from '@/components/Tooltip/'
import './Card.css'

type Props = {
  label: string
  value: string
  tooltip?: string
} & PropsWithChildren

export default function Card({ children, label, value, tooltip }: Props) {
  return (
    <div className="Card panel-xs">
      <div>
        <div className="Card-label">{label}</div>
        <div className="Card-value">{value}</div>
      </div>
      {tooltip && (
        <Tooltip text={tooltip}>
          <FontAwesomeIcon icon={faCircleInfo} color="var(--gray-300)" />
        </Tooltip>
      )}
      {children}
    </div>
  )
}
